export const ServiceTypes = {
  isUserService: 'isUserService',
  isGroupService: 'isGroupService',
  isReelService: 'isReelService',
  isNotificationService: 'isNotificationService',
};
